// src/pages/ThankYouPage.tsx
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const translations = {
    tr: {
        title: 'Teşekkürler!',
        message: 'Mesajınız başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.',
        back: 'Ana sayfaya dön'
    },
    en: {
        title: 'Thank You!',
        message: 'Your message has been sent. We will contact you shortly.',
        back: 'Back to homepage'
    }
};

export default function ThankYouPage() {
    const { lang } = useLanguage();
    const t = translations[lang];

    return (
        <main className="static-page">
            <h1>{t.title}</h1>
            <p>{t.message}</p>
            <Link to="/" className="back-button">← {t.back}</Link>
        </main>
    );
}
